import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { treeItemClasses, TreeView, TreeViewProps } from "@mui/x-tree-view";
import { useTheme } from "@mui/material";
import React from "react";

export type AavoTreeViewProps<Multiple extends boolean | undefined> = TreeViewProps<Multiple> & {
	onNodeToggleOnIconClick?: (event: React.SyntheticEvent, nodeIds: string[]) => void;
	itemHeight?: number;
};

export const AavoTreeView = <Multiple extends boolean | undefined>({
	defaultCollapseIcon,
	defaultExpandIcon,
	onNodeToggle,
	onNodeToggleOnIconClick,
	...other
}: AavoTreeViewProps<Multiple>) => {
	const theme = useTheme();
	const arrowIconColor = theme.palette.grey[700];
	return (
		<TreeView
			defaultCollapseIcon={
				defaultCollapseIcon ?? <FontAwesomeIcon icon={faChevronUp} color={arrowIconColor} />
			}
			defaultExpandIcon={
				defaultExpandIcon ?? <FontAwesomeIcon icon={faChevronDown} color={arrowIconColor} />
			}
			onNodeToggle={(event, nodeIds) => {
				onNodeToggle?.(event, nodeIds);
				event.persist();
				const iconClicked = (event.target as any).closest(".MuiTreeItem-iconContainer");
				if (iconClicked) {
					onNodeToggleOnIconClick?.(event, nodeIds);
				}
			}}
			sx={{
				[`& .${treeItemClasses.content}`]: {
					flexDirection: "row-reverse",
					width: "auto",
					gap: "0.75rem",
				},
			}}
			{...other}
		/>
	);
};
